import React, { useEffect, useState } from 'react';
import { Image, Spinner } from 'react-bootstrap';
import { FaLink } from 'react-icons/fa';
import ReactPlayer from 'react-player';

import Tooltip from 'reusable/Tooltip';
import { fetchAsset } from './helpers';

interface AssetData {
  type: string;
  url: string;
}

function Asset({
  url,
  label = '',
  previewUrl = '',
  playbackRate = 1,
  placeholder = '',
}) {
  const [data, setData] = useState<AssetData | undefined>();
  const [tooltip, setTooltip] = useState('Click to Copy');

  useEffect(() => {
    const controller = new AbortController();
    let isActive = true;
    let objectUrl = '';

    setData(undefined);
    fetchAsset(url, controller.signal)
      .then(res => {
        objectUrl = res.localURL;

        if (!isActive) {
          if (objectUrl) URL.revokeObjectURL(objectUrl);
          return;
        }

        setData({ type: res.type, url: objectUrl });
      })
      .catch(e => {
        if (e.name !== 'AbortError') console.error(e);
      });

    return () => {
      isActive = false;
      controller.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url]);

  if (!data) return <Spinner animation="border" className="asset-loader" />;

  return (
    <div className="asset-container">
      {label && (
        <div className="asset-label">
          {label}
          {previewUrl && (
            <Tooltip tooltipValue={tooltip}>
              <div>
                <FaLink
                  className="copy-button"
                  onClick={() => {
                    if (tooltip === 'Copying') return;

                    setTooltip('Copying');
                    navigator.clipboard.writeText(previewUrl).then(() => {
                      setTooltip('Copied');
                      setTimeout(() => setTooltip('Click to Copy'), 2000);
                    });
                  }}
                />
              </div>
            </Tooltip>
          )}
        </div>
      )}
      {data.type === 'video' && (
        <ReactPlayer
          url={data.url}
          controls
          key={url}
          playbackRate={playbackRate}
          height={''}
          width={''}
          className="asset-video"
          light={placeholder}
          playing
        />
      )}
      {data.type === 'image' && (
        <Image src={data.url} alt={url} key={url} className="asset-image" />
      )}
    </div>
  );
}

export default Asset;
